import {type ResolvedGroupedCartEntry, type ResolvedGroupedCartEntryKIT} from "~/Cart/models/CartData";
import {
  KITProductLineItem
} from "~/Cart/components/CartPage/ProductTable/ProductEntryList/KITProductEntry/KITProductLineItem";
import {type KITProductData} from "~/models/ProductData";
import {useRef} from "react";
import {type ProductEntryProps} from "~/Cart/components/CartPage/ProductTable/ProductEntryList/PlainProductEntry";
import type {ProductDescriptor} from "~/feature/ProductDescriptor/v1/types";

export const KitProductEntry = ({ groupingEntry, onRender, index, ...props }: ProductEntryProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const kitOnRender = () => containerRef.current && onRender?.(containerRef.current);

  return (
    <div ref={containerRef} data-index={index}>
      {splitKITEntry(groupingEntry).map((lineItem, index) => (
        <KITProductLineItem
          key={lineItem.packEntry.id}
          {...props}
          groupingEntry={lineItem}
          onRender={kitOnRender}
          index={index}
        />
      ))}
    </div>
  );
};

const getAllLineItems = (entry: ResolvedGroupedCartEntry) => entry.packGroups.flatMap((group) => group.packEntries);

const splitKITEntry = (entry: ResolvedGroupedCartEntry): ResolvedGroupedCartEntryKIT[] => {
  const allLineItems = getAllLineItems(entry);
  return allLineItems.map((lineItem) => ({
    cartEntry: entry.cartEntry,
    productDescriptor: entry.descriptors.find(
      (descriptor) => descriptor.priceReference === lineItem.priceReference,
    )! as ProductDescriptor<KITProductData>,
    packEntry: lineItem,
  }));
};
